{
  "settings": "Налаштування",
  "yourDigitalAssistant": "Ваш цифровий помічник",
  "getStarted": "Розпочати",
  "login": "Вхід",
  "loggingIn": "Увійти ...",
  "darkMode": "Нічний режим",
  "clearHistory": "Oчистити історію",
  "historyCleared": "Iсторія очищена",
  "changeLanguage": "Мова",
  "termsAndConditions": "Загальні положення та умови",
  "messagePlaceholder": "Введіть своє повідомлення тут ...",
  "messagePlaceholderDisabled": "Введення вимкнено ...",
  "feedbackTitle": "Напишіть свій відгук",
  "feedbackPlaceholder": "Розкажіть про це (необов’язково)",
  "feedbackSend": "Надіслати",
  "feedbackClose": "змикати",
  "sessionExpired": "Ваша сесія закінчилася через неактивність.",
  "startNewSession": "Розпочати нову сесію",
  "apiError": "На жаль! Щось пішло не так. Ми працюємо над тим, щоб виправити це, як тільки зможемо.",
  "apiErrorOffline": "Ви не підключені до Інтернету.",
  "tryAgain": "Спробуйте ще раз",
  "startOver": "Почніть з початку",
  "chatEnded": "Чат закінчився.",
  "chatEndedThankYou": "Дякуємо за спілкування з нами!",
  "closeChat": "Закрити",
  "startNewChat": "Знову поспілкуйся",
  "humanTakeoverStarted": "Ви переведені в службу обслуговування клієнтів ...",
  "humanTakeoverQueued": "Чекаємо підключитися до агента",
  "humanTakeoverAnAgent": "Агент",
  "humanTakeoverAgentEntered": "вступив у розмову",
  "humanTakeoverAgentLogout": "залишив розмову",
  "humanTakeoverTransfer": "Вас переводять до нового агента",
  "humanTakeoverEnded": "Тепер ви спілкуєтесь зі своїм цифровим помічником",
  "version": "Версія",
  "formIntroText": "Будь ласка, заповніть наступну форму, щоб почати спілкуватися з нами.",
  "formFirstName": "Ім'я",
  "formLastName": "Прізвище",
  "formName": "Ім'я",
  "formEmail": "Електронна пошта",
  "formWrongEmail": "Будь ласка, вкажіть дійсну адресу електронної пошти.",
  "formPhone": "Телефон",
  "formShipmentId": "Ідентифікатор відправлення",
  "formQuestion": "Ваше запитання",
  "formAccountNumber": "Номер рахунку (для бізнес-клієнтів)",
  "formAddress": "адресу",
  "formPostcode": "поштовий індекс",
  "formCity": "місто",
  "formCountry": "країна",
  "formSubmitButton": "Почати чат",
  "formEmptyFieldError": "Не дозволяється бути порожнім.",
  "formPhoneNumberValidationError": "Недійсний номер телефону.",
  "formInputIsBiggerThan50": "Повинно бути не більше 50 символів.",
  "formInputIsBiggerThan100": "Має бути не більше 100 символів.",
  "formInputIsBiggerThan2000": "Повинно бути не більше 2000 символів.",
  "widgetEventOnline": "Повідомлення DA: Користувач знову в мережі.",
  "widgetEventHidden": "Повідомлення DA: Віджет приховано.",
  "widgetEventVisible": "Повідомлення DA: Віджет видно.",
  "widgetEventVisibleMinimized": "Повідомлення DA: Віджет видимий, але мінімізований.",
  "widgetEventMinimized": "Повідомлення DA: Віджет зведено до мінімуму.",
  "widgetEventMaximized": "Повідомлення DA: Віджет максимізовано.",
  "widgetEventSessionExpired": "Повідомлення DA: Сесія віджетів минула.",
  "widgetEventHangupHuman": "Повідомлення DA: Користувач завершує сеанс захоплення людини.",
  "widgetEventUserTyping": "Повідомлення DA: користувач вводить текст.",
  "fileTooLarge": "Ви намагаєтесь долучити занадто великі файли.",
  "tooManyDiles": "Ви намагаєтесь вкласти занадто багато файлів.",
  "fileInvalidType": "Ви намагаєтесь вкласти недійсні типи файлів.",
  "attachmentsDropHere": "Опустіть сюди, щоб завантажити або",
  "attachmentsBrowse": "Перегляньте файли",
  "attachmentsExtenstionQuantity": "PDF або зображення (до 10 файлів)",
  "attachmentsSize": "до 30 МБ",
  "attachmentsFailedUploading": "Помилка завантаження",
  "attachmentsUploading": "Завантаження ...",
  "minimizeExpandText": "Живий чат з нами зараз!",
  "popupWidgetNotificationMessage": "Ви отримали нове повідомлення!",
  "tabWidgetNotificationMessage": "Нове повідомлення!",
  "datepickerSendButton": "відправити"
}
